import * as React from "react";
import { connect } from "react-redux";
import { GlobalState } from "../../../store";
import {
  User,
  Activity,
  Evidence,
  Link as LinkClass,
  File
} from "../../../api/classes";
import { Avatar, Typography, Card, Divider } from "@material-ui/core";
import FileIcon from "@material-ui/icons/Attachment";
import LinkIcon from "@material-ui/icons/Link";
import LinkMeta from "./linkMeta";
import CaseFile from "./file";
import * as moment from "moment";
import EvidenceIcon from "@material-ui/icons/Fingerprint";
import MoreSettings from "src/components/more";
import ApproveDialog from "src/components/dialogs/approveDialog";
import { DEFAULT_AVATAR } from "src/auth/auth";
import { Link } from "react-router-dom";

interface Props {
  user: User;
  evidence: Evidence;
  style?: React.CSSProperties;
  files: File[];
  links: LinkClass[];
  timeline?: boolean;
  onDelete?: (evidence: Evidence) => void;
}
class CaseEvidence extends React.Component<Props> {
  state = {
    deleteOpen: false
  };
  onDelete = () => {
    this.props.onDelete(this.props.evidence);
  };
  render() {
    const { user, evidence, style } = this.props;
    if (!this.props.user) {
      return null;
    }
    return (
      <Card
        style={{
          ...style,
          display: "flex",
          flexDirection: "column",
          marginTop: 16,
          maxWidth: 450,
          padding: 16,
          marginBottom: 16
        }}
      >
        {this.props.timeline && (
          <div style={{ paddingBottom: 4 }}>
            <div
              style={{ display: "flex", alignItems: "center", marginBottom: 4 }}
            >
              <EvidenceIcon style={{ width: 24, height: 24 }} />
              <Typography style={{ marginLeft: 12 }}>Evidence</Typography>
            </div>
            <Divider />
          </div>
        )}
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            marginTop: 16,
            marginBottom: 16,
            alignItems: "center"
          }}
        >
          <Avatar
            style={{ width: 20, height: 20 }}
            src={
              user && user.account_picture
                ? user.account_picture
                : DEFAULT_AVATAR
            }
          />
          <Link to={"/profile/" + user.id}>
            <Typography style={{ marginLeft: 8, fontSize: 13 }} variant="body2">
              {user && user.name}
            </Typography>
          </Link>
          <Typography style={{ marginLeft: 8, flex: 1 }} variant="caption">
            {moment(evidence.created_at).format("LLL")}
          </Typography>
          {this.props.onDelete && (
            <>
              <MoreSettings
                options={[
                  {
                    label: "Delete",
                    onClick: () => {
                      this.setState({ deleteOpen: true });
                    }
                  }
                ]}
              />
              <ApproveDialog
                open={this.state.deleteOpen}
                title="Delete Activity"
                description={
                  <>
                    Do you want to delete evidence by
                    <b>
                      {" " + (this.props.user && this.props.user.name) + " "}
                    </b>
                    from this case?
                  </>
                }
                onApprove={this.onDelete}
              />
            </>
          )}
        </div>
        <Typography
          style={{
            marginLeft: 8,
            fontSize: 13,
            overflowWrap: "break-word",
            wordBreak: "break-all"
          }}
          variant="body2"
        >
          {evidence.text}
        </Typography>
        {this.renderFiles()}
        {this.renderLinks()}
      </Card>
    );
  }
  renderFiles() {
    if (this.props.files) {
      return this.props.files.map(a => {
        if (a["evidence_id"] === this.props.evidence.id) {
          return <CaseFile file={a} />;
        }
      });
    }
  }
  renderLinks() {
    if (this.props.links) {
      return this.props.links.map(a => {
        if (a["evidence_id"] === this.props.evidence.id) {
          return (
            <div style={{}}>
              <LinkMeta link={a} />
            </div>
          );
        }
      });
    }
  }
}
function mapStateToProps(state: GlobalState, own: Props) {
  return {
    user:
      state.cases.users &&
      state.cases.users.find(u => u.id === own.evidence.user_id)
  };
}
function mapDispatchToProps(dispatch) {
  return {};
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CaseEvidence);



// WEBPACK FOOTER //
// ./src/pages/cases/components/evidence.tsx